module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.2fb07c8b.WOFF";